import GLightbox from 'glightbox';

export default class Lightbox {
    constructor() {
        let elements = document.querySelectorAll( '*[data-gallery]' );

        elements.forEach( ( element ) => {
            let galleryID = element.getAttribute( 'data-gallery');

            const lightbox = GLightbox( {
                selector: '*[data-gallery="' + galleryID + '"] *[data-lightbox]',
                touchNavigation: true,
                closeOnOutsideClick: true,
                zoomable: false,
                openEffect: 'fade',
                closeEffect: 'fade',
                height: 500,
            } );
        } );

        if ( document.body.classList.contains( 'template-post-detail' ) || document.body.classList.contains( 'template-news-archive') ) {
            this.contentLightbox();
        }
    }

    contentLightbox() {
        const lightboxContent = GLightbox( {
            selector: '.text-content a[href*=".jpg"]',
            touchNavigation: true,
            closeOnOutsideClick: true,
            zoomable: false,
            openEffect: 'fade',
            closeEffect: 'fade',
            height: 'auto'
        } );
    }
}